import { Flex, Image, useMediaQuery, Heading } from "@chakra-ui/react";
import { AuthContext } from "core/features/auth/AuthContext";
import useGetUserInfo from "core/features/auth/hooks/useGetUserInfo";
import useLogout from "core/features/auth/hooks/useLogout";
import colors from "core/resources/theme/colors";
import { useContext, useEffect, useState } from "react";
import { AiFillCaretDown } from "react-icons/ai";
import { MdMenu } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import SlantedButton from "ui/components/Button/SlantedButton";
import MenuNavegation from "./components/MenuNavegation";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function HeaderNavegation({ isOpen, setIsOpen }: Props) {
  const [isLargerThan1024] = useMediaQuery("(min-width: 1025px)");
  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate();

  const auth = useContext(AuthContext);
  const { isSuccess: isLoadedUser, data: user } = useGetUserInfo();
  const logout = useLogout();

  const handleLogout = () => {
    auth.signout();
    navigate("/");
  };

  useEffect(() => {
    setIsOpen(false);
  }, [navigate, setIsOpen]);

  return (
    <Flex
      flex="1"
      justify="end"
      gap={4}
      h="max-content"
      zIndex={10}
      position="relative"
      w={isOpen ? "100%" : "max-content"}
    >
      <Flex
        flexDir="column"
        align={isLargerThan1024 ? "flex-end" : "center"}
        bg={
          isLargerThan1024 && !isOpen
            ? `${colors.newYellow}`
            : `${colors.newPink}`
        }
        rounded={10}
        transition="all 0.3s ease"
        position={!isLargerThan1024 && isOpen ? "absolute" : "relative"}
        top={!isLargerThan1024 && isOpen ? "0" : "auto"}
        right={!isLargerThan1024 && isOpen ? "0" : "auto"}
        zIndex={!isLargerThan1024 && isOpen ? 999999 : "auto"}
        boxShadow={
          !isLargerThan1024 && isOpen ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none"
        }
      >
        {!isLargerThan1024 && (
          <Flex
            justify="end"
            onClick={() => setIsOpen(!isOpen)}
            w="100%"
            p={4}
            cursor="pointer"
            _hover={{ bg: colors.newPink }}
          >
            <MdMenu color="white" size={35} />
          </Flex>
        )}

        {(isOpen || isLargerThan1024) && (
          <Flex
            flexDir="column"
            gap={4}
            w="100%"
            align={isLargerThan1024 ? "flex-start" : "center"}
            textAlign={isLargerThan1024 ? "start" : "center"}
            bg={!isLargerThan1024 ? colors.newPink : "transparent"}
            p={!isLargerThan1024 ? 4 : 0}
          >
            {!isLargerThan1024 && (
              <Image
                src="https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/banners/logoacquapark-01.png"
                maxWidth={["100px", "100px", "100px", "200px", "240px"]}
                width="100%"
                cursor="pointer"
                onClick={() => navigate("/")}
              />
            )}

            <Flex
              justify={isLargerThan1024 ? "flex-start" : "center"}
              w="100%"
              flexDir={isLargerThan1024 ? "row" : "column"}
              alignItems={isLargerThan1024 ? "flex-start" : "center"}
            >
              <Flex
                flexDir={isLargerThan1024 ? "row" : "column"}
                gap={4}
                w={"100%"}
                justify={isLargerThan1024 ? "space-between" : "center"}
              >
                {isLargerThan1024 && !isOpen && (
                  <Heading
                    fontFamily="SuperMoodsRegular"
                    fontSize={["xl", "3xl", "4xl"]}
                    color={colors.newBlue}
                    fontWeight="bold"
                  >
                    SEU DIA MAIS FELIZ
                  </Heading>
                )}
                <Flex
                  flexDir={isLargerThan1024 ? "row" : "column"}
                  gap={4}
                  alignItems={isLargerThan1024 ? "flex-start" : "center"}
                >
                  {!isLoadedUser && (
                    <SlantedButton
                      title="ENTRAR"
                      color={isLargerThan1024 ? "white" : colors.newBlue}
                      bg={
                        isLargerThan1024 ? colors.newOrange : colors.newYellow
                      }
                      onClick={() => navigate("/auth/login")}
                    />
                  )}
                  <SlantedButton
                    title="INGRESSOS"
                    color={isLargerThan1024 ? "white" : colors.newBlue}
                    bg={isLargerThan1024 ? colors.newPink : colors.newYellow}
                    onClick={() => navigate("/ingresso")}
                  />
                </Flex>
              </Flex>
            </Flex>
            <Flex
              flexDir={isLargerThan1024 ? "row" : "column"}
              justify="space-between"
              align={isLargerThan1024 ? "center" : "center"}
              gap={4}
              w="100%"
              p={isLargerThan1024 ? 0 : 4}
            >
              <Flex
                gap={4}
                fontWeight="medium"
                align="center"
                flexDir={isLargerThan1024 ? "row" : "column"}
                m="auto"
                w="100%"
              >
                <Heading
                  color={isLargerThan1024 ? colors.newBlue : colors.newYellow}
                  variant="superCellMagic"
                  _hover={{
                    color: isLargerThan1024 ? colors.newBlue : colors.newYellow,
                  }}
                  cursor="pointer"
                  fontSize="md"
                  onClick={() => navigate("/parque-aquatico")}
                >
                  PARQUE AQUÁTICO
                </Heading>
                <Heading
                  color={isLargerThan1024 ? colors.newBlue : colors.newYellow}
                  variant="superCellMagic"
                  _hover={{
                    color: isLargerThan1024 ? colors.newBlue : colors.newYellow,
                  }}
                  cursor="pointer"
                  fontSize="md"
                  onClick={() => navigate("/duvidas")}
                >
                  DÚVIDAS FREQUENTES
                </Heading>
                <Heading
                  color={isLargerThan1024 ? colors.newBlue : colors.newYellow}
                  variant="superCellMagic"
                  _hover={{
                    color: isLargerThan1024 ? colors.newBlue : colors.newYellow,
                  }}
                  cursor="pointer"
                  fontSize="md"
                  onClick={() => navigate("/contato")}
                >
                  CONTATO
                </Heading>
                <Heading
                  color={isLargerThan1024 ? colors.newBlue : colors.newYellow}
                  variant="superCellMagic"
                  _hover={{
                    color: isLargerThan1024 ? colors.newBlue : colors.newYellow,
                  }}
                  cursor="pointer"
                  fontSize="md"
                  onClick={() => navigate("/aniversariante")}
                >
                  ANIVERSARIANTE
                </Heading>
                <Heading
                  color={isLargerThan1024 ? colors.newBlue : colors.newYellow}
                  variant="superCellMagic"
                  _hover={{
                    color: isLargerThan1024 ? colors.newBlue : colors.newYellow,
                  }}
                  cursor="pointer"
                  fontSize="md"
                  onClick={() => navigate("/como-chegar")}
                >
                  COMO CHEGAR
                </Heading>
                {isLoadedUser && user && (
                  <Heading
                    color={isLargerThan1024 ? colors.newBlue : colors.newYellow}
                    variant="superCellMagic"
                    _hover={{
                      color: isLargerThan1024
                        ? colors.newBlue
                        : colors.newYellow,
                    }}
                    cursor="pointer"
                    fontSize="md"
                    onClick={() => navigate("/minhas-compras")}
                  >
                    MINHAS COMPRAS
                  </Heading>
                )}
              </Flex>

              {user && isLargerThan1024 && (
                <Flex
                  cursor="pointer"
                  onClick={() => setOpenMenu(!openMenu)}
                  zIndex={100}
                >
                  <Flex align="center" gap={2}>
                    <Flex
                      w="40px"
                      h="40px"
                      bg={colors.newBlue}
                      rounded="full"
                      align="center"
                      justify="center"
                      color="white"
                    >
                      {user?.name.charAt(0)}
                    </Flex>
                    <Flex>
                      <AiFillCaretDown size={15} />
                    </Flex>
                  </Flex>
                  {openMenu && (
                    <Flex
                      right={["20px", "40px", "0"]}
                      bottom={["20px", "30px", "-200"]}
                      position="absolute"
                    >
                      <MenuNavegation user={user} handleLogout={handleLogout} />
                    </Flex>
                  )}
                </Flex>
              )}
            </Flex>

            {user && !isLargerThan1024 && (
              <Flex flexDir="column" align="center" gap={4} px={4} mb={4}>
                <Heading
                  variant="superCellMagic"
                  color={colors.white}
                  fontWeight="medium"
                  fontSize="md"
                >
                  Olá, {user.name}
                </Heading>

                <Heading
                  variant="superCellMagic"
                  _hover={{ color: colors.newYellow }}
                  cursor="pointer"
                  color={colors.newYellow}
                  fontSize="md"
                  onClick={() => navigate("/perfil")}
                >
                  MEUS DADOS
                </Heading>
                <Heading
                  variant="superCellMagic"
                  _hover={{ color: colors.newYellow }}
                  cursor="pointer"
                  fontSize="md"
                  color={colors.newYellow}
                  onClick={() => logout()}
                >
                  SAIR
                </Heading>
              </Flex>
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}
